import React from 'react';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';
const MEASURE_NAME = 'hitsRendered';

const withHitLoadTime = (WrappedComponent) => {
    let namedWrappedComponent = class extends React.Component {
        constructor(props) {
            super(props);
        }

        componentDidMount() {
            const {userTiming} = haWrapper;
            const alreadyMeasured =
                userTiming.getEntriesByName(MEASURE_NAME).length > 0;

            if (!alreadyMeasured) {
                userTiming.measureAndSend(MEASURE_NAME);
                sendCustomAnalytics(MEASURE_NAME, 'measure', (analytics) => ({
                    [MEASURE_NAME]: analytics.duration
                }));
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    /* istanbul ignore next */
    namedWrappedComponent.displayName = `withHitsRendered(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;
    return namedWrappedComponent;
};
export default withHitLoadTime;
